import { render, staticRenderFns } from "./page.vue?vue&type=template&id=ea0a1a9c&scoped=true&"
var script = {}
import style0 from "./page.vue?vue&type=style&index=0&id=ea0a1a9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea0a1a9c",
  null
  
)

component.options.__file = "page.vue"
export default component.exports